import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AfmOther } from '../models/afm-other.model';
import { AfmOtherService } from '../service/afm-other.service';


@Component({
  selector: 'app-edit-ga-transient',
  templateUrl: './edit-ga-transient.component.html',
  styleUrls: ['./edit-ga-transient.component.scss']
})
export class EditGaTransientComponent implements OnInit {
  afmOther: AfmOther;
  originalAfmOther: AfmOther;
  isNew = false;
  isLoading = false;
  airportID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  selectedGatParking: string;
  selectedGatCharted: boolean;
  selectedGatDescription: string;

  constructor(private _matDialogRef: MatDialogRef<EditGaTransientComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _afmOtherService: AfmOtherService) {
    this.afmOther = data.afmOther || new AfmOther();
    this.isNew = data.isNew || false;
    this.airportID = data.airID;
    this.originalAfmOther = Object.assign(new AfmOther(), data.afmOther);
    this.itemsToChange = new Set<number> ();
    if (this.afmOther.gatParking === true) {
      this.selectedGatParking = 'Yes';
    } else if (this.afmOther.gatParking === false) {
      this.selectedGatParking = 'No';
    } else {
      this.selectedGatParking = 'Unknown';
    }
    this.selectedGatCharted = this.afmOther.gatCharted ? this.afmOther.gatCharted : false;
    this.selectedGatDescription = this.afmOther.gatDescription ? this.afmOther.gatDescription : '';
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      parking: new FormControl(this.selectedGatParking),
      charted: new FormControl(this.selectedGatCharted),
      description: new FormControl(this.selectedGatDescription, [Validators.maxLength(150)])
    });
    if (this.selectedGatParking === 'Unknown' || this.selectedGatParking === 'No') {
      this.formGroup.controls.description.disable();
    }
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      if (this.formGroup.controls.parking.value === 'Yes') {
        this.afmOther.gatParking = true;
      } else if (this.formGroup.controls.parking.value === 'No') {
        this.afmOther.gatParking = false;
      } else {
        this.afmOther.gatParking = null;
      }
      if (this.afmOther.gatParking) {
        this.afmOther.gatCharted = this.formGroup.controls.charted.value;
        if (this.formGroup.get('description').value.length > 0) {
          this.afmOther.gatDescription = this.formGroup.get('description').value;
        } else {
          this.afmOther.gatDescription = null;
        }
      } else {
        this.afmOther.gatCharted = false;
        this.afmOther.gatDescription = null;
      }
      res = await this._afmOtherService.putAfmOther(this.airportID, this.afmOther);
      Object.assign(this.afmOther, AfmOther.parse(res));
      this.afmOther = AfmOther.parse(res);
      this.close({cancelBtnClicked: false, success: true, afmOther: this.afmOther});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.afmOther, this.originalAfmOther);
    }
    this._matDialogRef.close(data);
  }
}
